import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _24a98bbe = () => interopDefault(import('..\\..\\..\\pages\\admin\\index.vue' /* webpackChunkName: "pages/admin/index" */))
const _71944225 = () => interopDefault(import('..\\..\\..\\pages\\blog\\index.vue' /* webpackChunkName: "pages/blog/index" */))
const _9f40d2be = () => interopDefault(import('..\\..\\..\\pages\\index-old.vue' /* webpackChunkName: "pages/index-old" */))
const _46923002 = () => interopDefault(import('..\\..\\..\\pages\\account\\cart.vue' /* webpackChunkName: "pages/account/cart" */))
const _40306e06 = () => interopDefault(import('..\\..\\..\\pages\\account\\cart-for-later.vue' /* webpackChunkName: "pages/account/cart-for-later" */))
const _3fc8eb20 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\index.vue' /* webpackChunkName: "pages/account/dashboard/index" */))
const _6dea5593 = () => interopDefault(import('..\\..\\..\\pages\\account\\forgot-password.vue' /* webpackChunkName: "pages/account/forgot-password" */))
const _1b277c77 = () => interopDefault(import('..\\..\\..\\pages\\account\\login.vue' /* webpackChunkName: "pages/account/login" */))
const _934395f6 = () => interopDefault(import('..\\..\\..\\pages\\account\\register.vue' /* webpackChunkName: "pages/account/register" */))
const _7129b938 = () => interopDefault(import('..\\..\\..\\pages\\landing\\new-home.vue' /* webpackChunkName: "pages/landing/new-home" */))
const _0aa13cca = () => interopDefault(import('..\\..\\..\\pages\\landing\\pay-balance.vue' /* webpackChunkName: "pages/landing/pay-balance" */))
const _ff575a86 = () => interopDefault(import('..\\..\\..\\pages\\order\\cancel.vue' /* webpackChunkName: "pages/order/cancel" */))
const _c22a6060 = () => interopDefault(import('..\\..\\..\\pages\\order\\success.vue' /* webpackChunkName: "pages/order/success" */))
const _555eb74b = () => interopDefault(import('..\\..\\..\\pages\\pages\\400.vue' /* webpackChunkName: "pages/pages/400" */))
const _556ccecc = () => interopDefault(import('..\\..\\..\\pages\\pages\\401.vue' /* webpackChunkName: "pages/pages/401" */))
const _5597154f = () => interopDefault(import('..\\..\\..\\pages\\pages\\404.vue' /* webpackChunkName: "pages/pages/404" */))
const _395f8257 = () => interopDefault(import('..\\..\\..\\pages\\pages\\about-us.vue' /* webpackChunkName: "pages/pages/about-us" */))
const _966e8ef6 = () => interopDefault(import('..\\..\\..\\pages\\pages\\brands.vue' /* webpackChunkName: "pages/pages/brands" */))
const _3062aaf3 = () => interopDefault(import('..\\..\\..\\pages\\pages\\catalogs.vue' /* webpackChunkName: "pages/pages/catalogs" */))
const _0e328a5e = () => interopDefault(import('..\\..\\..\\pages\\pages\\coming-soon.vue' /* webpackChunkName: "pages/pages/coming-soon" */))
const _62595224 = () => interopDefault(import('..\\..\\..\\pages\\pages\\contact-us.vue' /* webpackChunkName: "pages/pages/contact-us" */))
const _5dd81316 = () => interopDefault(import('..\\..\\..\\pages\\pages\\dropshipping.vue' /* webpackChunkName: "pages/pages/dropshipping" */))
const _752484de = () => interopDefault(import('..\\..\\..\\pages\\pages\\fajas-colombianas-wholesale-sign-up.vue' /* webpackChunkName: "pages/pages/fajas-colombianas-wholesale-sign-up" */))
const _0187b82d = () => interopDefault(import('..\\..\\..\\pages\\pages\\faq.vue' /* webpackChunkName: "pages/pages/faq" */))
const _76369a16 = () => interopDefault(import('..\\..\\..\\pages\\pages\\how-does-it-work.vue' /* webpackChunkName: "pages/pages/how-does-it-work" */))
const _1cd811da = () => interopDefault(import('..\\..\\..\\pages\\pages\\jeans-colombianos-wholesale-sign-up.vue' /* webpackChunkName: "pages/pages/jeans-colombianos-wholesale-sign-up" */))
const _7bea443e = () => interopDefault(import('..\\..\\..\\pages\\pages\\minimum-advertised-price-policy.vue' /* webpackChunkName: "pages/pages/minimum-advertised-price-policy" */))
const _9030b160 = () => interopDefault(import('..\\..\\..\\pages\\pages\\privacy-policy.vue' /* webpackChunkName: "pages/pages/privacy-policy" */))
const _9d765846 = () => interopDefault(import('..\\..\\..\\pages\\pages\\products.vue' /* webpackChunkName: "pages/pages/products" */))
const _ddf3e296 = () => interopDefault(import('..\\..\\..\\pages\\pages\\returns-policy.vue' /* webpackChunkName: "pages/pages/returns-policy" */))
const _7e80798c = () => interopDefault(import('..\\..\\..\\pages\\pages\\sample-policy.vue' /* webpackChunkName: "pages/pages/sample-policy" */))
const _41dc4e34 = () => interopDefault(import('..\\..\\..\\pages\\pages\\shipping-policies.vue' /* webpackChunkName: "pages/pages/shipping-policies" */))
const _30ac626d = () => interopDefault(import('..\\..\\..\\pages\\pages\\terms-and-conditions.vue' /* webpackChunkName: "pages/pages/terms-and-conditions" */))
const _8a0f67bc = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\address-directory.vue' /* webpackChunkName: "pages/account/dashboard/address-directory" */))
const _08d171ca = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\affiliate.vue' /* webpackChunkName: "pages/account/dashboard/affiliate" */))
const _693d07b6 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\affiliate-commissions.vue' /* webpackChunkName: "pages/account/dashboard/affiliate-commissions" */))
const _2f67b5b2 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\buy-again.vue' /* webpackChunkName: "pages/account/dashboard/buy-again" */))
const _a791d834 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\change-password.vue' /* webpackChunkName: "pages/account/dashboard/change-password" */))
const _49d994ae = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\my-account.vue' /* webpackChunkName: "pages/account/dashboard/my-account" */))
const _dc3e1918 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\my-orders.vue' /* webpackChunkName: "pages/account/dashboard/my-orders" */))
const _767866a0 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\my-statement.vue' /* webpackChunkName: "pages/account/dashboard/my-statement" */))
const _8cd4c8d4 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\preorders.vue' /* webpackChunkName: "pages/account/dashboard/preorders" */))
const _4d362e63 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\price-catalog.vue' /* webpackChunkName: "pages/account/dashboard/price-catalog" */))
const _9d374696 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\sales-executive.vue' /* webpackChunkName: "pages/account/dashboard/sales-executive" */))
const _37323f72 = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _6ef46185 = () => interopDefault(import('..\\..\\..\\pages\\balance\\payments\\_type\\cancel.vue' /* webpackChunkName: "pages/balance/payments/_type/cancel" */))
const _f766cbf0 = () => interopDefault(import('..\\..\\..\\pages\\balance\\payments\\_type\\success.vue' /* webpackChunkName: "pages/balance/payments/_type/success" */))
const _03dcdb13 = () => interopDefault(import('..\\..\\..\\pages\\order\\payments\\_type\\cancel.vue' /* webpackChunkName: "pages/order/payments/_type/cancel" */))
const _e7195b8c = () => interopDefault(import('..\\..\\..\\pages\\order\\payments\\_type\\success.vue' /* webpackChunkName: "pages/order/payments/_type/success" */))
const _6ef25d2e = () => interopDefault(import('..\\..\\..\\pages\\agents\\_handle.vue' /* webpackChunkName: "pages/agents/_handle" */))
const _03c23f5a = () => interopDefault(import('..\\..\\..\\pages\\blog\\_handle.vue' /* webpackChunkName: "pages/blog/_handle" */))
const _39a27970 = () => interopDefault(import('..\\..\\..\\pages\\checkout\\_type.vue' /* webpackChunkName: "pages/checkout/_type" */))
const _49ed67ed = () => interopDefault(import('..\\..\\..\\pages\\collections\\_handle.vue' /* webpackChunkName: "pages/collections/_handle" */))
const _9bb15b50 = () => interopDefault(import('..\\..\\..\\pages\\products\\_handle.vue' /* webpackChunkName: "pages/products/_handle" */))
const _0fe242c8 = () => interopDefault(import('..\\..\\..\\pages\\collections\\_handleCollection\\products\\_handle.vue' /* webpackChunkName: "pages/collections/_handleCollection/products/_handle" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _24a98bbe,
    name: "admin"
  }, {
    path: "/blog",
    component: _71944225,
    name: "blog"
  }, {
    path: "/index-old",
    component: _9f40d2be,
    name: "index-old"
  }, {
    path: "/account/cart",
    component: _46923002,
    name: "account-cart"
  }, {
    path: "/account/cart-for-later",
    component: _40306e06,
    name: "account-cart-for-later"
  }, {
    path: "/account/dashboard",
    component: _3fc8eb20,
    name: "account-dashboard"
  }, {
    path: "/account/forgot-password",
    component: _6dea5593,
    name: "account-forgot-password"
  }, {
    path: "/account/login",
    component: _1b277c77,
    name: "account-login"
  }, {
    path: "/account/register",
    component: _934395f6,
    name: "account-register"
  }, {
    path: "/landing/new-home",
    component: _7129b938,
    name: "landing-new-home"
  }, {
    path: "/landing/pay-balance",
    component: _0aa13cca,
    name: "landing-pay-balance"
  }, {
    path: "/order/cancel",
    component: _ff575a86,
    name: "order-cancel"
  }, {
    path: "/order/success",
    component: _c22a6060,
    name: "order-success"
  }, {
    path: "/pages/400",
    component: _555eb74b,
    name: "pages-400"
  }, {
    path: "/pages/401",
    component: _556ccecc,
    name: "pages-401"
  }, {
    path: "/pages/404",
    component: _5597154f,
    name: "pages-404"
  }, {
    path: "/pages/about-us",
    component: _395f8257,
    name: "pages-about-us"
  }, {
    path: "/pages/brands",
    component: _966e8ef6,
    name: "pages-brands"
  }, {
    path: "/pages/catalogs",
    component: _3062aaf3,
    name: "pages-catalogs"
  }, {
    path: "/pages/coming-soon",
    component: _0e328a5e,
    name: "pages-coming-soon"
  }, {
    path: "/pages/contact-us",
    component: _62595224,
    name: "pages-contact-us"
  }, {
    path: "/pages/dropshipping",
    component: _5dd81316,
    name: "pages-dropshipping"
  }, {
    path: "/pages/fajas-colombianas-wholesale-sign-up",
    component: _752484de,
    name: "pages-fajas-colombianas-wholesale-sign-up"
  }, {
    path: "/pages/faq",
    component: _0187b82d,
    name: "pages-faq"
  }, {
    path: "/pages/how-does-it-work",
    component: _76369a16,
    name: "pages-how-does-it-work"
  }, {
    path: "/pages/jeans-colombianos-wholesale-sign-up",
    component: _1cd811da,
    name: "pages-jeans-colombianos-wholesale-sign-up"
  }, {
    path: "/pages/minimum-advertised-price-policy",
    component: _7bea443e,
    name: "pages-minimum-advertised-price-policy"
  }, {
    path: "/pages/privacy-policy",
    component: _9030b160,
    name: "pages-privacy-policy"
  }, {
    path: "/pages/products",
    component: _9d765846,
    name: "pages-products"
  }, {
    path: "/pages/returns-policy",
    component: _ddf3e296,
    name: "pages-returns-policy"
  }, {
    path: "/pages/sample-policy",
    component: _7e80798c,
    name: "pages-sample-policy"
  }, {
    path: "/pages/shipping-policies",
    component: _41dc4e34,
    name: "pages-shipping-policies"
  }, {
    path: "/pages/terms-and-conditions",
    component: _30ac626d,
    name: "pages-terms-and-conditions"
  }, {
    path: "/account/dashboard/address-directory",
    component: _8a0f67bc,
    name: "account-dashboard-address-directory"
  }, {
    path: "/account/dashboard/affiliate",
    component: _08d171ca,
    name: "account-dashboard-affiliate"
  }, {
    path: "/account/dashboard/affiliate-commissions",
    component: _693d07b6,
    name: "account-dashboard-affiliate-commissions"
  }, {
    path: "/account/dashboard/buy-again",
    component: _2f67b5b2,
    name: "account-dashboard-buy-again"
  }, {
    path: "/account/dashboard/change-password",
    component: _a791d834,
    name: "account-dashboard-change-password"
  }, {
    path: "/account/dashboard/my-account",
    component: _49d994ae,
    name: "account-dashboard-my-account"
  }, {
    path: "/account/dashboard/my-orders",
    component: _dc3e1918,
    name: "account-dashboard-my-orders"
  }, {
    path: "/account/dashboard/my-statement",
    component: _767866a0,
    name: "account-dashboard-my-statement"
  }, {
    path: "/account/dashboard/preorders",
    component: _8cd4c8d4,
    name: "account-dashboard-preorders"
  }, {
    path: "/account/dashboard/price-catalog",
    component: _4d362e63,
    name: "account-dashboard-price-catalog"
  }, {
    path: "/account/dashboard/sales-executive",
    component: _9d374696,
    name: "account-dashboard-sales-executive"
  }, {
    path: "/",
    component: _37323f72,
    name: "index"
  }, {
    path: "/balance/payments/:type?/cancel",
    component: _6ef46185,
    name: "balance-payments-type-cancel"
  }, {
    path: "/balance/payments/:type?/success",
    component: _f766cbf0,
    name: "balance-payments-type-success"
  }, {
    path: "/order/payments/:type?/cancel",
    component: _03dcdb13,
    name: "order-payments-type-cancel"
  }, {
    path: "/order/payments/:type?/success",
    component: _e7195b8c,
    name: "order-payments-type-success"
  }, {
    path: "/agents/:handle?",
    component: _6ef25d2e,
    name: "agents-handle"
  }, {
    path: "/blog/:handle",
    component: _03c23f5a,
    name: "blog-handle"
  }, {
    path: "/checkout/:type?",
    component: _39a27970,
    name: "checkout-type"
  }, {
    path: "/collections/:handle?",
    component: _49ed67ed,
    name: "collections-handle"
  }, {
    path: "/products/:handle?",
    component: _9bb15b50,
    name: "products-handle"
  }, {
    path: "/collections/:handleCollection?/products/:handle?",
    component: _0fe242c8,
    name: "collections-handleCollection-products-handle"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
